module.exports = new __parcel__URL__("waves-rt.8b8ca7d5.png").toString();